import { FC } from 'react';
import { PaginationProps } from '@/types';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

const Pagination: FC<PaginationProps> = ({
                                                 page,
                                                 totalPages,
                                                 onPageChange,
                                                 size,
                                                 totalElements,
                                                 controlsPrefix
                                               }) => {
  const startItem = page * size + 1;
  const endItem = Math.min((page +1) * size, totalElements);

  const getPageNumbers = () => {
    const pages: (number | string)[] = [];
    const maxVisible = 5;
    const currentPage = page + 1;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);

      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);

      if (start > 2) {
        pages.push('...');
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (end < totalPages - 1) {
        pages.push('...');
      }

      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <div className="flex flex-col gap-2 px-6 py-3 bg-white border-t border-gray-200 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex w-full items-center justify-center text-center text-sm text-gray-500 whitespace-nowrap sm:w-auto sm:justify-start sm:text-left">
        Mostrando {startItem} a {endItem} de {totalElements} resultados
      </div>
      <div className="flex items-center justify-center space-x-2 sm:justify-start">
        {controlsPrefix}
        <button
          onClick={() => onPageChange(0)}
          disabled={page === 0}
          className="hidden p-2 text-gray-500 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer sm:inline-flex"
          type="button"
        >
          <ChevronsLeft size={16} />
        </button>

        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page === 0}
          className="p-2 text-gray-500 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
          type="button"
        >
          <ChevronLeft size={16} />
        </button>

        <div className="flex space-x-1">
          {getPageNumbers().map((p, index) => (
            <button
              key={index}
              onClick={() => typeof p === 'number' ? onPageChange(p-1) : undefined}
              disabled={typeof p === 'string'}
              className={`px-3 py-1 text-sm rounded-md  cursor-pointer ${
                (page + 1) === p
                  ? 'bg-indigo-600 text-white'
                  : typeof p === 'string'
                    ? 'text-gray-400 cursor-default'
                    : 'text-gray-700 hover:bg-gray-100'
              }`}
              type="button"
            >
              {p}
            </button>
          ))}
        </div>

        <button
          onClick={() => onPageChange(page + 1)}
          disabled={(page+1) === totalPages}
          className="p-2 text-gray-500 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed  cursor-pointer"
          type="button"
        >
          <ChevronRight size={16} />
        </button>

        <button
          onClick={() => onPageChange(totalPages-1)}
          disabled={(page +1) === totalPages}
          className="hidden p-2 text-gray-500 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer sm:inline-flex"
          type="button"
        >
          <ChevronsRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
